import { getDefaultHeight, SVG } from "./utils";

type Props = {
  color?: string;
} & React.SVGProps<SVGSVGElement>;

export const SkipIcon: React.FC<Props> = ({ color, ...svgProps }) => {
  return (
    <SVG
      viewBox="0 0 18.5 9.3"
      xmlns="http://www.w3.org/2000/svg"
      height={getDefaultHeight(svgProps, 9.3)}
      {...svgProps}
      fill={svgProps.fill ?? "none"}
      stroke={color ?? svgProps.stroke ?? "currentColor"}
      strokeWidth="1.5"
      strokeLinecap="round"
    >
      <path d="M.8 7.4c2.4-9 13.4-9 15.4 1" />
      <path d="m12.2 6.9 4 1.5 1.5-4" />
    </SVG>
  );
};
